import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

const AuthChecker: React.FC = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      const token = Cookies.get("userToken");
      if (!token) {
        setOpen(true); // Open dialog when token expires
      }
    }, 5000); // Check every 5 seconds

    return () => clearInterval(interval);
  }, [navigate]);

  const handleLogin = () => {
    Cookies.remove("userToken");
    setOpen(false);
    navigate("/login"); // Redirect to login page
  };

  return (
    <Dialog open={open} onClose={handleLogin}>
      <DialogTitle>Session Expired</DialogTitle>
      <DialogContent>
        <Typography>
          Your session has expired. Please re-login to continue.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleLogin} color="primary" variant="contained">
          Login
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AuthChecker;
